var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { SABox } from '../box';
import { SAUX360Theme } from '../theme';
import { getBreakpoints, responsiveStyles } from '../utilities/responsive-styles';
var StackWrapper = styled(SABox)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var spacing = _a.spacing, theme = _a.theme, divider = _a.divider;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      & > * + * {\n        ", "\n        ", "\n      }\n    "], ["\n      & > * + * {\n        ",
        "\n        ",
        "\n      }\n    "])), responsiveStyles(spacing)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ",
        "\n        "])), function (space) { return "\n            margin-top: " + theme.size.spacer[space] + ";\n          "; }), responsiveStyles(divider, spacing)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ",
        "\n        "])), function (variant, space) { return "\n          " + (variant &&
        "\n          border-top-width: " + theme.separator[variant].thickness + ";\n          border-top-color: " + theme.separator[variant].color + ";\n          border-top-style: solid;\n          ") + "\n          " + (space && "padding-top: " + theme.size.spacer[space]) + "\n          "; }));
});
/** `Stack` is a basic layout component that manages the spacing between child elements, automatically removing any extra space at the beginning and end. */
export function SAStack(_a) {
    var children = _a.children, spacing = _a.spacing, separator = _a.separator, theme = _a.theme, rest = __rest(_a, ["children", "spacing", "separator", "theme"]);
    var spacingValues = getBreakpoints(spacing);
    var separatorValues = getBreakpoints(separator);
    return (React.createElement(StackWrapper, __assign({ spacing: spacingValues, divider: separatorValues, theme: theme, "data-testid": "StackWrapper" }, rest), React.Children.map(children, function (child) {
        return React.createElement(SABox, { "data-testid": "StackItem" }, child);
    })));
}
SAStack.defaultProps = {
    spacing: undefined,
    separator: undefined,
    theme: SAUX360Theme,
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=stack.component.js.map